import type { GridFilterModel } from '@packages/fenrir/components';

import { getSessionGridState } from './get-session-grid-state';

export const getInitialFilterState = (
  key: string,
  defaultFilter: GridFilterModel,
): GridFilterModel => {
  const gridState = getSessionGridState(key);
  return gridState.filter?.filterModel
    ? gridState.filter?.filterModel
    : defaultFilter;
};
